var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.63807 0.195262C1.37772 -0.0650874 0.955612 -0.0650874 0.695262 0.195262C0.434913 0.455612 0.434913 0.877722 0.695262 1.13807L6.22386 6.66667H1.16667C0.798477 6.66667 0.5 6.96514 0.5 7.33333C0.5 7.70152 0.798477 8 1.16667 8H7.83235C7.8354 8 7.83844 7.99999 7.84149 7.99995C7.92561 7.99893 8.00957 7.98208 8.08852 7.94941C8.16657 7.91712 8.23973 7.86937 8.30332 7.80615C8.30379 7.80568 8.30427 7.80521 8.30474 7.80474C8.30521 7.80427 8.30568 7.80379 8.30615 7.80332C8.30521 7.80427 8.30427 7.80521 8.30332 7.80615C8.24221 7.8669 8.16938 7.91589 8.08852 7.94941M8.5 7.33235V0.666667C8.5 0.298477 8.20152 9.31323e-09 7.83333 9.31323e-09C7.46514 9.31323e-09 7.16667 0.298477 7.16667 0.666667V5.72386L1.63807 0.195262",
    fill: "#DC180C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRedIcon);
export default __webpack_public_path__ + "static/media/arrow-red-icon.2f7cfb22ba2406013561ee103200a0d4.svg";
export { ForwardRef as ReactComponent };